import { spokenShortcut } from "@/lib/shortcuts";
import { useShortcutStore } from "@/stores/shortcut-store";
import { useT } from "@/i18n";
import { layoutMessages } from "@/i18n/messages/layout";

/** Desktop names the pan gesture as bound on this platform; web has none. */
export function useRailPanModeLabel(isDesktopTauri: boolean): string {
  const t = useT(layoutMessages);
  useShortcutStore((state) => state.overrides["shortcut.workspace.peek"]);
  return isDesktopTauri
    ? t("dragCanvasShortcut", {
        shortcut: spokenShortcut("shortcut-pan-workspace"),
      })
    : t("dragCanvas");
}
